import * as Toast from "../framework/components/toast";
import * as API from "../framework/api";

document.querySelector("#export-program-fundae")?.addEventListener("click", onExportProgramJson);
document
  .querySelectorAll(".export-session-fundae")
  .forEach((el) => el.addEventListener("click", () => onExportSessionJson(el.dataset.training_session_id)));
document
  .querySelectorAll(".export-session-cost-fundae")
  .forEach((el) => el.addEventListener("click", () => onExportSessionCostJson(el.dataset.training_session_id)));
document.querySelector(".js-save-date-fgf-fundae")?.addEventListener("click", () => onSaveDateFundae("fgf"));
document.querySelector(".js-save-date-igf-fundae")?.addEventListener("click", () => onSaveDateFundae("igf"));
document.querySelector(".js-save-date-af-fundae")?.addEventListener("click", () => onSaveDateFundae("af"));
document.querySelector(".js-date-fundae-import")?.addEventListener("keydown", (e) => {
  if (e.key !== "Enter") return;
  if (document.querySelector(".js-save-date-fgf-fundae")) onSaveDateFundae("fgf");
  else if (document.querySelector(".js-save-date-igf-fundae")) onSaveDateFundae("igf");
  else if (document.querySelector(".js-save-date-af-fundae")) onSaveDateFundae("af");
});

function onExportProgramJson() {
  const programId = document.querySelector("#export-program-fundae").dataset.program_id;

  download_file(p`/fundae/${programId}/export_fundae_program_json`);
}

function onExportSessionJson(sessionId) {
  download_file(p`/fundae/${sessionId}/export_fundae_session_json`);
}

function onExportSessionCostJson(sessionId) {
  download_file(p`/fundae/${sessionId}/export_fundae_session_cost_json`);
}

function download_file(url_action) {
  API.fetch(url_action, {
    method: "GET",
    credentials: "same-origin",
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        Toast.show("#error-toast");
      }
    })
    .then(({ url }) => {
      const a = document.createElement("a");
      a.href = url;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      a.remove();
      Toast.show("#success-toast");
    });
}

function onSaveDateFundae(type) {
  const dateInput = document.querySelector(".js-date-fundae-import");
  const date = dateInput?.value;

  if (!date) {
    Toast.show("#error-toast");
    return;
  }

  let url, body;

  if (type === "af") {
    const programId = document.querySelector(".js-save-date-af-fundae").dataset.programId;
    url = p`/ajax/programs/${programId}/update`;
    body = JSON.stringify({
      program: {
        imported_on_fundae: date,
      },
    });
  } else {
    const buttonClass = `.js-save-date-${type}-fundae`;
    const trainingSessionId = document.querySelector(buttonClass).dataset.trainingSessionId;
    url = p`/ajax/training_sessions/${trainingSessionId}/update`;
    body = JSON.stringify({
      training_session: {
        [`${type}_imported_at`]: date,
      },
    });
  }

  API.fetch(url, {
    method: "POST",
    redirect: "manual",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  }).then((response) => {
    if (response.ok) {
      Toast.show("#success-toast-update-date");
    } else {
      Toast.show("#error-toast-update-date");
    }
  });
}
